import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=b70e980a&"
import script from "./SubscriptionView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports